import { useTranslation } from 'react-i18next';

import { EuropaceProcessEventsRequestButton } from '~/features/leadDetails/components/LeadSideInfo/ExternalServices/Europace/EuropaceProcessEventsDialog/EuropaceProcessEventsRequestButton.tsx';

type Props = {
    isPending: boolean;
    requestEuropaceProcessEvents: () => void;
};
export const EuropaceProcessEventsDialogTitle: React.FC<Props> = ({ isPending, requestEuropaceProcessEvents }) => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center justify-between">
            <span className="text-base font-medium text-midnight">
                {t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.MODAL_TITLE')}
            </span>
            <EuropaceProcessEventsRequestButton isPending={isPending} onClick={requestEuropaceProcessEvents} />
        </div>
    );
};
